import { CommonModule } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
} from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AuthService } from '../../services/auth/auth.service';
import { SharedModule } from '../shared/shared.module';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { FooterComponent } from './components/footer/footer.component';
import { ForgotPasswordDialogComponent } from './components/forgot-password/forgot-password-dialog.component';
import { HeaderComponent } from './components/header/header.component';
import { SideMenuComponent } from './components/side-menu/side-menu.component';
import { UserChangePasswordFormComponent } from './components/user-change-password/user-change-password-form.component';
import { CoreRoutingModule } from './core-routing.module';
import { HttpConfigInterceptor } from './interceptors/http-config.interceptor';
import { AuthComponent } from './pages/auth/auth.component';
import { NotAuthorizedComponent } from './pages/not-authorized/not-authorized.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';

export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, `assets/i18n/`, '.json');
}

@NgModule({
  declarations: [
    AuthComponent,
    HeaderComponent,
    FooterComponent,
    SideMenuComponent,
    PageNotFoundComponent,
    NotAuthorizedComponent,
    BreadcrumbComponent,
    ForgotPasswordDialogComponent,
    UserChangePasswordFormComponent,
  ],
  imports: [
    // ExtregisterModule,
    CommonModule,
    HttpClientModule,
    CoreRoutingModule,
    FormsModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: httpTranslateLoader,
        deps: [HttpClient],
      },
    }),
  ],
  providers: [
    AuthService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpConfigInterceptor,
      multi: true,
    },
  ],
  exports: [
    SideMenuComponent,
    HeaderComponent,
    FooterComponent,
    BreadcrumbComponent,
    ForgotPasswordDialogComponent,
    UserChangePasswordFormComponent,
  ],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    if (parentModule) {
      throw new Error(
        'CoreModule is already loaded. Import it in the AppModule only.'
      );
    }
  }
}
